import { createContext, useContext } from "react";

export type TextHighlighter = (text: string, markHighlighted: (text: string) => string) => string;

export const TextHighlighterContext = createContext<TextHighlighter>(null);

export const useTextHighlighter = () => useContext(TextHighlighterContext);
